import { useCallback, useState } from "react";
import { useAppContext } from "../../../AppContext";
import { UserRole } from "../../../common/enums";
import { getCurrentUserRole } from "../../../common/infrastructure/helpers/userHelper";
import { IUserModel } from "../../../common/infrastructure/hooks/useAuthentication";

/**
 * The referral program is for the people who run a studio: its owner, who pays Planny and
 * gets the discount, and its managers, who often know the other studios. Global admins see
 * it too, so the Planny team can check what owners see.
 */
export const canSeeReferralProgram = (currentUser?: IUserModel | null): boolean => {
  if (!currentUser) {
    return false;
  }

  const role = getCurrentUserRole(currentUser);
  return (
    role === UserRole.Tenant ||
    role === UserRole.Employee_Manager ||
    role === UserRole.GlobalAdmin
  );
};

/** The sidebar's "refer a studio" entry and the dialog it opens. */
export const useReferralProgram = () => {
  const { currentUser, setShowSidebar } = useAppContext();
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  // The dialog lives outside the sidebar, so the sidebar can close behind it.
  const openDialog = useCallback(() => {
    setShowSidebar(false);
    setIsDialogVisible(true);
  }, [setShowSidebar]);

  const closeDialog = useCallback(() => setIsDialogVisible(false), []);

  return {
    isAvailable: canSeeReferralProgram(currentUser),
    isDialogVisible,
    openDialog,
    closeDialog,
  };
};
